export const watchMediaQuery = (query, onChange) => {
  const media = window.matchMedia(query);
  const listener = (event) => onChange(event.matches);

  onChange(media.matches);

  if (typeof media.addEventListener === "function") {
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }

  media.addListener(listener);
  return () => media.removeListener(listener);
};
